import type { ReactElement } from 'react';
import { cn } from '@xdocs/ui';
import { AppearanceSection } from './AppearanceSection.js';
import { DangerZoneSection } from './DangerZoneSection.js';
import { NotificationsPrefsSection } from './NotificationsPrefsSection.js';
import { ProfileSection } from './ProfileSection.js';
import { SettingsNav } from './SettingsNav.js';
import { useSettingsT } from './useSettingsT.js';
import styles from './SettingsPage.module.css';

/**
 * `/settings` (F10 container). Profile + Appearance (theme/language) +
 * Notifications-prefs live directly on this page; Sessions (F13) and
 * Billing (F19/F20/F24/F26/F45/F46/F56/F57) are separate routes
 * (`/settings/sessions`, `/settings/billing`) reachable via `<SettingsNav>`.
 */
export function SettingsPage(): ReactElement {
  const { t } = useSettingsT();

  return (
    <div className={cn(styles['page'])}>
      <div className={cn(styles['header'])}>
        <p className={cn(styles['eyebrow'])}>{t('settings:page.eyebrow')}</p>
        <h1 className={cn(styles['title'])}>{t('settings:page.title')}</h1>
      </div>

      <SettingsNav />

      <ProfileSection />
      <AppearanceSection />
      <NotificationsPrefsSection />
      <DangerZoneSection />
    </div>
  );
}
